export const NEWS_SEGMENT = 27430;
export const SUBSCRIBED = "subscribed";
